module.exports = __webpack_public_path__ + "static/media/express-icon.bcaacd97.svg";